import { DataLogin } from './autenticacion.service';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

export enum ESTADOS_PAGO {
  PENDIENTE = 'Pendiente',
  VERIFICADO = 'Exitoso',
  VERIFICAR = 'Verificar'
}

import { environment } from 'src/environments/environment';

const smartHomeUrl = environment.smartHomeUrl;
@Injectable({
  providedIn: 'root'
})
export class PagosService {  

  constructor(
    private _http: HttpClient
  ) { }

  public detallePago = new BehaviorSubject(null);
  public mostrarModalCargarPagos = new BehaviorSubject(false);
  public mostrarModalPreviewPagos = new BehaviorSubject<boolean>(false);
  public datosPreviewPagos = new BehaviorSubject<RespuestaPreviewPagos | null>(null);
  public archivoPreviewPagos = new BehaviorSubject<File | null>(null);

  public cambiarDetallePago(detallePago: number): void {
    this.detallePago.next(detallePago);
  }

  public cambiarMostrarModalCargarPagos(nuevoMostrarModalCargarPagos: boolean): void {
    this.mostrarModalCargarPagos.next(nuevoMostrarModalCargarPagos);
  }

  public cambiarMostrarModalPreviewPagos(nuevoMostrarModalPreviewPagos: boolean): void {
    this.mostrarModalPreviewPagos.next(nuevoMostrarModalPreviewPagos);
  }

  public cambiarDatosPreviewPagos(nuevosDatos: RespuestaPreviewPagos | null): void {
    this.datosPreviewPagos.next(nuevosDatos);
  }

  public cambiarArchivoPreviewPagos(nuevoArchivo: File | null): void {
    this.archivoPreviewPagos.next(nuevoArchivo);
  }

  traerPagosUnidad(page: number, palabrasClave: string, estado: number, fechaInicio: number, fechaFinal: number) {
    const requestUrl = `${smartHomeUrl}api/pagos?status=${estado}&key=${palabrasClave}&page=${page + 1}&cant=8&date_begin=${fechaInicio}&date_end=${fechaFinal}`;
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));

    const headers = new HttpHeaders({
      unidadId: String(loginData.company_id),
    });

    return <Observable<RespuestaPagos>>this._http.get(requestUrl, { headers });
  }

  traerDetallePago(idPago: number) {
    const requestUrl = `${smartHomeUrl}api/pagos/pago/${idPago}`;

    const headers = new HttpHeaders({
      dataPago: "true"
    });

    return <Observable<RespuestaPago>>this._http.get(requestUrl, { headers });
  }

  verificarPago(idPago: number) {
    const requestUrl = `${smartHomeUrl}api/pagos/comprobante`;

    const body = {
      id: idPago,
      status_payment: ESTADOS_PAGO.VERIFICADO,
      status: 0
    };

    return <Observable<RespuestaPago>>this._http.patch(requestUrl, body);
  }

  cargarPagos(archivo: File) {
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));
    const requestUrl = `${smartHomeUrl}api/unidades/unidad/${loginData.company_id}`;

    const headers = new HttpHeaders({
      dataUploadPagos: "true"
    });

    const formData = new FormData();
    formData.append('pagos', archivo);

    return <Observable<RespuestaCargaPagos>>this._http.patch(requestUrl, formData, { headers });
  }

  descargarPlantilla(unidadId?: number): Observable<HttpResponse<Blob>> {
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));
    const id = unidadId || loginData?.company_id;
    const requestUrl = `${smartHomeUrl}api/pagos/carga-masiva/plantilla/${id}`;

    let headers = new HttpHeaders();
    if (loginData?.token) {
      headers = headers.set('token', loginData.token);
    }

    return this._http.get(requestUrl, {
      headers,
      responseType: 'blob',
      observe: 'response'
    });
  }

  previewCargaPagos(archivo: File, unidadId?: number): Observable<RespuestaPreviewPagos> {
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));
    const id = unidadId || loginData?.company_id;
    const requestUrl = `${smartHomeUrl}api/pagos/carga-masiva/preview`;

    let headers = new HttpHeaders();
    if (loginData?.token) {
      headers = headers.set('token', loginData.token);
      headers = headers.set('Authorization', `Bearer ${loginData.token}`);
    }

    const formData = new FormData();
    formData.append('archivo', archivo);
    formData.append('unidadId', String(id));

    return <Observable<RespuestaPreviewPagos>>this._http.post(requestUrl, formData, { headers });
  }

  confirmarCargaMasiva(archivo: File, unidadId?: number): Observable<RespuestaConfirmarCargaMasiva> {
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));
    const id = unidadId || loginData?.company_id;
    const requestUrl = `${smartHomeUrl}api/pagos/carga-masiva`;

    let headers = new HttpHeaders();
    if (loginData?.token) {
      headers = headers.set('token', loginData.token);
      headers = headers.set('Authorization', `Bearer ${loginData.token}`);
    }

    const formData = new FormData();
    formData.append('archivo', archivo);
    formData.append('unidadId', String(id));

    return <Observable<RespuestaConfirmarCargaMasiva>>this._http.post(requestUrl, formData, { headers });
  }
}

export interface RespuestaConfirmarCargaMasiva {
  data?: any;
  message?: string;
  ok?: boolean;
}

export interface FilaPreviewPago {
  fila: number;
  unidad: string;
  concepto: string | null;
  valor: number | null;
  resultado: 'insertada' | 'actualizada' | 'descartada' | string;
  motivo: string | null;
  unidad_encontrada: boolean;
}

export interface ResumenPreviewPagos {
  total: number;
  insertadas: number;
  actualizadas: number;
  descartadas: number;
}

export interface DataPreviewPagos {
  archivo: string;
  unidad_residencial: string;
  resumen: ResumenPreviewPagos;
  filas: FilaPreviewPago[];
}

export interface RespuestaPreviewPagos {
  data: DataPreviewPagos;
  message: string;
}

export interface RespuestaCargaPagos {
  data: {
    csvP: {
      record: [],
      message: [],
      inser: number,
      update: number,
      error: number
    }
  }
}


export interface RespuestaPago {
  data: {
    data_pago: Pago
  }
}

export interface RespuestaPagos {
  data: {
    pagos: Pago[]
  }
}

export interface Pago {
  id: number;
  place_id: number;
  type_charge: string;
  value: number;
  date: number;
  type_payment: string;
  status_payment: string;
  status: number;
  site_name: string;
  area_name: string;
  user_name: string;
  user_lastname: string;
  voucher?: string;
}